export const BACKEND_URL = "/v1"
export const LIVE_STREAM_ALIAS_URL = "https://g2.ipcamlive.com/player/player.php?alias="
export const BUNNY_TUS_UPLOAD_URL = "https://video.bunnycdn.com/tusupload"